<template>
  <div>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="10" lg="8" xl="6" offset-lg="1" offset-xl="2">
          <v-btn class="greenb--text" @click="$router.go(-1)" text>
            <v-icon left>
              mdi-arrow-left
            </v-icon>
            Zurück
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12" lg="10" offset-lg="1" xl="8" offset-xl="2" class="pb-0">
          <h2 class="greend--text">Versandinformationen</h2>
        </v-col>
      </v-row>

      <v-row v-if="$store.state.cart.length == 0">
        <v-col sm="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <v-card outlined align="center">
            <v-card-text>
              Es wurden keine Artikel ausgewählt.
            </v-card-text>
            <v-card-actions class="mb-4">
              <v-spacer></v-spacer>
              <v-btn small outlined color="greenb" to="shop">
                Zurück zum Online-Shop
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12" sm="8" lg="7" xl="6" offset-lg="1" offset-xl="2">
          <CustomerData />
        </v-col>
        <v-col cols="12" sm="4" lg="3" xl="2" order="first" order-sm="last" v-if="$vuetify.breakpoint.smAndUp">
          <CheckoutBox />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CheckoutBox from "../components/shop/CheckoutBox";
import CustomerData from "../components/shop/CustomerData";

export default {
  data() {
    return {};
  },
  components: {
    CheckoutBox,
    CustomerData
  },
  mounted() {
    this.$vuetify.goTo(0);
  }
};
</script>
